import { render, staticRenderFns } from "./energize.vue?vue&type=template&id=3b062b3f"
import script from "./energize.vue?vue&type=script&lang=js"
export * from "./energize.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports